import './EasySoftwareCards.scss'

import React, { FunctionComponent } from 'react'

import EasySoftwareCardItem, {
  EasySoftwareCardItemType,
} from './EasySoftwareCardItem'


export interface EasySoftwareCardsType {
  displayText: string
  cardsList: {
    contentItems: EasySoftwareCardItemType[]
  }
  pageContentItemId: string
  editorPath: string
}

const EasySoftwareCards: FunctionComponent<EasySoftwareCardsType> = (props) => (
  <div className='Cards'>
    <div className='Cards-items'>
      {props.cardsList &&
        props.cardsList.contentItems &&
        props.cardsList.contentItems.map((item) => (
          <EasySoftwareCardItem
            data={item}
            key={item.contentItemId}
            pageContentItemId={props.pageContentItemId}
            editorPath={
              props.editorPath +
              `,cid-${item.contentItemId},easySoftwareCardItem,cardItemPerex,html`
            }
          />
        )
      )}
    </div>
  </div>
)

export default EasySoftwareCards
